import { z } from 'zod';
import type { ProcessCloverCardNotPresentPaymentRequest } from '../../../types/ipg/clover/clover-card-not-present-payment.types';
import { AddressSchema } from '../../../backend_config.types';
import {
    MetadataRichHostedCardTokenSchemaShape,
    TokenOnlyHostedCardTokenSchemaShape,
    TransactionDetailsSchema,
} from '../../payment.schemas';
import { CustomerDetailsSchema } from '../../customer-details.schemas';
import { CloverTokenizationTokenSchema } from './clover-tokenization.schemas';
import { IpgBrowserTokenizationResultSchema } from '../ipg-browser-tokenization-result-registry.schemas';
import { JsonNonnegativeLosslessNumberInputSchema } from '../../common.schemas';

const ProcessCloverCardNotPresentPaymentRequestCommonShape = {
    terminal_device_uuid: z.string().uuid(),
    single_use_token: CloverTokenizationTokenSchema,
    tokenization_result: IpgBrowserTokenizationResultSchema.optional(),
    cardholder_name: z.string().min(1),
    expiry_date: z
        .string()
        .regex(/^\d{2}\/\d{2}$/)
        .optional(),
    billing_address: AddressSchema.optional(),
    customer_details: CustomerDetailsSchema,
    stored_for_future_use: z.boolean(),
    transaction_details: TransactionDetailsSchema,
    surcharge_amount: JsonNonnegativeLosslessNumberInputSchema,
    convenience_fee_amount: JsonNonnegativeLosslessNumberInputSchema,
    total_fee_amount: JsonNonnegativeLosslessNumberInputSchema,
    total_amount_paid: JsonNonnegativeLosslessNumberInputSchema,
} as const satisfies z.ZodRawShape;

export const ProcessCloverCardNotPresentPaymentRequestSchema: z.ZodType<ProcessCloverCardNotPresentPaymentRequest> =
    z.union([
        z
            .object({
                ...ProcessCloverCardNotPresentPaymentRequestCommonShape,
                ...MetadataRichHostedCardTokenSchemaShape,
            })
            .strict(),
        z
            .object({
                ...ProcessCloverCardNotPresentPaymentRequestCommonShape,
                ...TokenOnlyHostedCardTokenSchemaShape,
            })
            .strict(),
    ]);
